const en = {
  title: 'Page not found',
};

export default en;
